import throttle from 'lodash/throttle';
import pick from 'lodash/pick';
import { applyMiddleware, combineReducers, compose, createStore } from 'redux';
import { reducer as formReducer } from 'redux-form';
import { reducer as toastrReducer } from 'react-redux-toastr';
import { legitReducers } from 'apex-legit-service';
import { apexMenuReducers } from 'apex-online-menu';
import { saveState, loadState } from 'utils';
import { NAMESPACE as APP_NAMESPACE, reducer as appReducer } from 'containers/App';
import { reducer as searchContainerReducer, NAMESPACE as SEARCH_CONTAINER_NAMESPACE } from 'containers/Search';
import { reducer as loginReducer, NAMESPACE as LOGIN_NAMESPACE } from 'containers/Login';
import { reducer as searchServiceReducer, NAMESPACE as SEARCH_SERVICE_NAMESPACE } from 'services/search';
import { reducer as actionsServiceReducer, NAMESPACE as ACTIONS_SERVICE_NAMESPACE } from 'services/actions';
import {
  reducer as recentDepositsServiceReducer,
  NAMESPACE as RECENT_DEPOSITS_SERVICE_NAMESPACE,
} from 'services/recentDeposits';
import { reducer as detailsServiceReducer, NAMESPACE as DETAILS_SERVICE_NAMESPACE } from 'services/details';
import { reducer as updateWireServiceReducer, NAMESPACE as UPDATE_WIRE_SERVICE_NAMESPACE } from 'services/updateWire';
import {
  reducer as suspendWireServiceReducer,
  NAMESPACE as SUSPEND_WIRE_SERVICE_NAMESPACE,
} from 'services/suspendWire';
import { reducer as loginTypeServiceReducer, NAMESPACE as LOGIN_TYPE_SERVICE_NAMESPACE } from 'services/LoginType/';
import { reducer as ssoLoginServiceReducer, NAMESPACE as SSO_LOGIN_NAMESPACE } from 'services/SsoLogin';
import { reducer as atlasServiceReducer, NAMESPACE as ATLAS_NAMESPACE } from 'services/atlasRequest';
import { reducer as addressServiceReducer, NAMESPACE as ADDRESS_NAMESPACE } from 'services/addressPreview';

export default function (middlewares) {
  const hasWindow = typeof window !== 'undefined';

  //redux-devtools-extension support
  const composeEnhancers = hasWindow ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose : compose;

  const loginPersistedState = { [LOGIN_NAMESPACE]: loadState(LOGIN_NAMESPACE) || { isApexUserChecked: false } };
  //create the redux store
  const store = createStore(
    combineReducers({
      [APP_NAMESPACE]: appReducer,
      form: formReducer,
      [SEARCH_CONTAINER_NAMESPACE]: searchContainerReducer,
      toastr: toastrReducer,
      [SEARCH_SERVICE_NAMESPACE]: searchServiceReducer,
      [ACTIONS_SERVICE_NAMESPACE]: actionsServiceReducer,
      [RECENT_DEPOSITS_SERVICE_NAMESPACE]: recentDepositsServiceReducer,
      [DETAILS_SERVICE_NAMESPACE]: detailsServiceReducer,
      [UPDATE_WIRE_SERVICE_NAMESPACE]: updateWireServiceReducer,
      [SUSPEND_WIRE_SERVICE_NAMESPACE]: suspendWireServiceReducer,
      [LOGIN_NAMESPACE]: loginReducer,
      [LOGIN_TYPE_SERVICE_NAMESPACE]: loginTypeServiceReducer,
      [SSO_LOGIN_NAMESPACE]: ssoLoginServiceReducer,
      [ATLAS_NAMESPACE]: atlasServiceReducer,
      [ADDRESS_NAMESPACE]: addressServiceReducer,
      ...legitReducers,
      ...apexMenuReducers,
    }),
    { ...loginPersistedState },
    composeEnhancers(applyMiddleware(...middlewares)),
  );

  // Subscribe to store changes. This is where we can save stuff to localStorage.
  store.subscribe(
    throttle(() => {
      const state = store.getState();

      const persistable = {
        [LOGIN_NAMESPACE]: pick(state[LOGIN_NAMESPACE] || {}, ['isApexUserChecked']),
      };
      if (Object.keys(persistable[LOGIN_NAMESPACE]).length > 0) {
        saveState(LOGIN_NAMESPACE, { ...persistable[LOGIN_NAMESPACE] });
      }
    }, 1000),
  );

  return store;
}



// WEBPACK FOOTER //
// ./src/configureStore.js